import { render, staticRenderFns } from "./ViewCardTemplate.vue?vue&type=template&id=3a890408"
import script from "./ViewCardTemplate.vue?vue&type=script&lang=js"
export * from "./ViewCardTemplate.vue?vue&type=script&lang=js"
import style0 from "./ViewCardTemplate.vue?vue&type=style&index=0&id=3a890408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports